import React from "react";
import ContentContainer from "components/Container";

/**
 * @deprecated Use the new <EmptyState variant="error" /> component instead
 * @todo Remove
 */
export const Error = ({ children = "ERROR" }) => {
  return <ContentContainer>{children}</ContentContainer>;
};
